/**
 * .table-flow 열 라벨
 *
 * 모바일에서 표를 문단으로 흘리면 thead 가 감춰진다(scss/cms/custom/table.scss).
 * 그래서 숫자만 남는 칸은 무슨 값인지 알 수 없다. th 에 .flow-label 을 달아두면
 * 그 열의 칸마다 열 제목이 라벨로 붙는다.
 *
 *   <th class="flow-label">열린이슈</th>
 *   <th class="flow-label" data-flow-label="방치">방치일수</th>   문구가 다를 때
 *   <th data-flow-width="3.6rem">사용</th>                        그 열만 고정 폭
 *
 * data-flow-width 는 오른쪽에 모아 붙인 숫자 칸이 행마다 글자 길이가 달라
 * 들쭉날쭉해 보일 때 쓴다. 폭을 묶으면 열이 맞는다. flow-label 과 무관하게
 * 따로 줄 수 있다.
 *
 * 라벨을 셀이 아니라 <table> 에 심는다. 커스텀 속성 --flow-label-N 을 열 개수만큼
 * 올려두면 CSS 가 td:nth-child(N)::before 로 그린다. 이렇게 하는 이유:
 *
 *  - DOM 노드가 하나도 안 늘어난다. 행이 몇 개든 쓰는 값은 열 개수만큼이다.
 *  - 검색·페이징으로 tbody 를 갈아끼워도 살아남는다. 셀에 박아두는 방식은
 *    tbody 를 다시 그릴 때마다 재실행해야 하고 한 번 놓치면 라벨이 사라진다.
 *  - 데스크톱에서는 CSS 가 아예 안 그린다. 숨길 노드 자체가 없다.
 */
function applyFlowLabels(table) {
    // 머리글 행은 첫 tr 하나만 본다. 두 줄짜리 머리글은 열 위치가 어긋나므로 건너뛴다.
    const headRow = table.querySelector('thead tr');
    if (!headRow) return;

    const cells = headRow.children;

    for (let i = 0; i < cells.length; i++) {
        const th = cells[i];
        const col = i + 1;

        if (th.classList.contains('flow-label')) {
            const text = (th.dataset.flowLabel ?? th.textContent).trim();
            // JSON.stringify 가 따옴표와 역슬래시를 CSS 문자열 규칙대로 감싸준다
            if (text !== '') table.style.setProperty('--flow-label-' + col, JSON.stringify(text));
        }

        const width = (th.dataset.flowWidth || '').trim();
        if (width !== '') {
            table.style.setProperty('--flow-width-' + col, width);
            // 고정 폭 칸만 flex 로 만들어 라벨을 왼쪽, 값을 오른쪽에 붙인다.
            // CSS 로는 "폭이 설정된 칸"을 고를 수 없어서 display 도 여기서 심는다.
            table.style.setProperty('--flow-display-' + col, 'flex');
        }
    }
}

function initFlowLabels(root) {
    (root || document).querySelectorAll('table.table-flow').forEach(applyFlowLabels);
}

$(function () {
    initFlowLabels();
});

// ajax 로 목록을 통째로 다시 그리는 화면 대응. 이미 심은 표에 다시 심어도 같은 값이라
// 부작용이 없다.
$(document).ajaxComplete(function () {
    initFlowLabels();
});
